<mat-dialog-content
    class="loan-profitability-mat-dialog-content"
    id="loan-profitability-mat-dialog-content"
>
    <div class="loan-profitability-container">
        <div class="loan-profitability-matadata-area">
            <div class="lp-main-title-area">
                <div class="lp-main-cross-container">
                    <i class="fas fa-times" mat-dialog-close></i>
                </div>
                <div class="lp-main">
                    <div class="lp-main-title">Loan Profitability</div>
                    <a class="lp-export" (click)="exportToExcel()">
                        <mat-icon fontSet="far" fontIcon="fa-file-excel"></mat-icon>
                    </a>
                </div>
            </div>
            <div class="lp-metadata-detail-area">
                <div class="lp-metadata-detail-sub-area">
                    <div class="lp-metadata-detail-sub-title">Loan #</div>
                    <div
                        mat-dialog-close
                        class="lp-metadata-detail-sub-data lp-hyperlink"
                        (click)="clickLoanNumber(dialogData.dialogHeaderData.loanNumber)"
                    >
                        {{ dialogData.dialogHeaderData.loanNumber }}
                    </div>
                </div>
                <div class="lp-metadata-detail-sub-area">
                    <div class="lp-metadata-detail-sub-title">Borrower</div>
                    <div class="lp-metadata-detail-sub-data">
                        {{ dialogData.dialogHeaderData.borrower }}
                    </div>
                </div>
                <div class="lp-metadata-detail-sub-area">
                    <div class="lp-metadata-detail-sub-title">Loan Originator</div>
                    <div class="lp-metadata-detail-sub-data">
                        {{ dialogData.dialogHeaderData.loanOriginator }}
                    </div>
                </div>
                <div class="lp-metadata-detail-sub-area">
                    <div class="lp-metadata-detail-sub-title">Branch</div>
                    <div class="lp-metadata-detail-sub-data">
                        {{ dialogData.dialogHeaderData.branch }}
                    </div>
                </div>
            </div>
        </div>
        <div class="horizontal-line add-margin-right-20"></div>
        <div *ngIf="!isDataLoading && !hasLPData">
            <no-data-screen [noDataType]="noDataType"></no-data-screen>
        </div>
        <div *ngIf="isDataLoading">
            <spin-loader [type]="'spinner'" class="table-spinner"></spin-loader>
        </div>
        <div
            class="lp-data-area loan-profitability-dialog-scrollbar"
            *ngIf="!isDataLoading && hasLPData"
        >
            <div class="lp-data-summary-container">
                <div class="lp-data-summary-area">
                    <div class="lp-data-summary-title">Gross Profit (Loss)</div>
                    <div
                        class="lp-data-summary-value"
                        [ngStyle]="{ color: dialogData.dialogHeaderData.color }"
                    >
                        {{ dialogData.dialogHeaderData.grossProfit }}
                    </div>
                    <div
                        mat-dialog-close
                        class="lp-data-view-all lp-hyperlink"
                        (click)="viewAllTransactions(dialogData.dialogHeaderData.loanNumber)"
                    >
                        View all transactions
                    </div>
                </div>
                <div class="lp-data-summary-area">
                    <div class="lp-data-summary-title">BPS</div>
                    <div
                        class="lp-data-summary-value"
                        [ngStyle]="{ color: dialogData.dialogHeaderData.color }"
                    >
                        {{ dialogData.dialogHeaderData.totalBps }}
                    </div>
                </div>
            </div>
            <div class="lp-data-detail-container" id="lp-data-detail-container">
                <div
                    class="lp-data-detail-summary-area"
                    *ngFor="let mainData of dialogData.dialogExpansionData; let indx = index"
                >
                    <mat-expansion-panel
                        (opened)="mainData.hasExpanded = true; isMainExansionDirty = true"
                        (closed)="mainData.hasExpanded = false"
                        hideToggle
                        class="lp-data-detail-expantion-pannel"
                    >
                        <mat-expansion-panel-header class="lp-data-detail-expantion-pannel-header">
                            <mat-panel-title
                                class="lp-data-detail-expantion-pannel-title detail-summary-title"
                            >
                                <div class="lp-data-detail-expantion-pannel-title-left">
                                    <div
                                        class="lp-expantion-toggle-icon lp-expantion-toggle-icon-level-1"
                                    >
                                        <i
                                            class="fas fa-caret-right"
                                            *ngIf="!mainData.hasExpanded"
                                        ></i>
                                        <i
                                            class="fas fa-caret-down"
                                            *ngIf="mainData.hasExpanded"
                                        ></i>
                                    </div>
                                    <div>{{ mainData.mainGroupTitle }}</div>
                                </div>
                                <div
                                    class="lp-data-detail-expantion-pannel-title-right"
                                    [ngStyle]="{ color: mainData.color }"
                                >
                                    <div class="lp-data-detail-title-value">
                                        {{ mainData.mainGroupAmountTotal }}
                                    </div>
                                    <div class="lp-data-detail-title-value">
                                        {{ mainData.mainGroupBpsTotal }}
                                    </div>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div [ngStyle]="{ display: isMainExansionDirty ? 'block' : 'none' }">
                            <div
                                class="lp-data-detail"
                                *ngFor="let subData of mainData.subGroupData"
                            >
                                <mat-expansion-panel
                                    (opened)="subData.hasExpanded = true"
                                    (closed)="subData.hasExpanded = false"
                                    hideToggle
                                    class="lp-data-detail-expantion-pannel"
                                >
                                    <mat-expansion-panel-header
                                        class="lp-data-detail-expantion-pannel-header"
                                    >
                                        <mat-panel-title
                                            class="lp-data-detail-expantion-pannel-title data-summary-title"
                                        >
                                            <div class="lp-data-detail-expantion-pannel-title-left">
                                                <div
                                                    class="lp-expantion-toggle-icon lp-expantion-toggle-icon-level-2"
                                                >
                                                    <i
                                                        class="fas fa-caret-right"
                                                        *ngIf="!subData.hasExpanded"
                                                    ></i>
                                                    <i
                                                        class="fas fa-caret-down"
                                                        *ngIf="subData.hasExpanded"
                                                    ></i>
                                                </div>
                                                <div>{{ subData.subGroupTitle }}</div>
                                            </div>
                                            <div
                                                class="lp-data-detail-expantion-pannel-title-right subtitle-title-right"
                                                [ngStyle]="{ color: subData.color }"
                                            >
                                                <div class="lp-data-detail-title-value">
                                                    {{ subData.subGroupAmountTotal }}
                                                </div>
                                                <div class="lp-data-detail-title-value">
                                                    {{ subData.subGroupBpsTotal }}
                                                </div>
                                            </div>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div>
                                        <div
                                            class="lp-data-detail lp-data-detail-row"
                                            *ngFor="let data of subData.data"
                                        >
                                            <div class="lp-data-detail-expantion-pannel-title-left">
                                                <div class="lp-expantion-toggle-icon-level-3"></div>
                                                <div class="lp-data-detail-line-title">
                                                    {{ data.title }}
                                                </div>
                                            </div>
                                            <div
                                                class="lp-data-detail-expantion-pannel-title-right"
                                                [ngStyle]="{ color: data.color }"
                                            >
                                                <div class="lp-data-detail-title-value">
                                                    {{ data.amount }}
                                                </div>
                                                <div class="lp-data-detail-title-value">
                                                    {{ data.bps }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                            </div>
                        </div>
                    </mat-expansion-panel>
                    <div
                        class="horizontal-line"
                        *ngIf="indx < dialogData.dialogExpansionData.length - 1"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
